import React, { Component, PropTypes } from 'react'
import Lightbox from 'lightbox-react'

const video_data = {
  smite: {
    title: 'Smite | PlayVS',
    width: '560',
    height: '315',
    src: 'https://www.youtube.com/embed/CnNrEb9PycM',
    style: {
      maxWidth: '97%',
      position: 'absolute',
      left: 0,
      right: 0,
      margin: 'auto',
      top: '50%',
      transform: 'translateY(-50%)'
    }
  },
  lol: {
    title: 'League Of Legends | PlayVS',
    width: '560',
    height: '315',
    src: 'https://www.youtube.com/embed/NKwOZYWiXuY',
    style: {
      maxWidth: '97%',
      position: 'absolute',
      left: 0,
      right: 0,
      margin: 'auto',
      top: '50%',
      transform: 'translateY(-50%)'
    }
  }
}

const Video = ({ data }) => {
  if (data) {
    return (
      <iframe title={data.title} width={data.width} height={data.height} style={data.style} src={data.src} />
    )
  } else {
    return <React.Fragment />
  }
}

const videos = {
  smite: <Video data={video_data.smite} />,
  lol: <Video data={video_data.lol} />
}

export class BiColumn__games extends Component {
  constructor() {
    super()

    this.state = {
      isOpen: false,
      index: 'lol'
    }

    this.openLightbox = this.openLightbox.bind(this)
    this.closeLightbox = this.closeLightbox.bind(this)

    this.openLol = this.openLol.bind(this)
    this.openSmite = this.openSmite.bind(this)
  }

  openLightbox() {
    this.setState({ isOpen: true })
  }

  openLol() {
    this.setState({ isOpen: true, index: 'lol' })
  }

  openSmite() {
    this.setState({ isOpen: true, index: 'smite' })
  }

  closeLightbox() {
    this.setState({ isOpen: false })
  }

  render() {
    console
    return (
      <div className="gameLibrary">
        <section className="section--shorten">
          <div className="container">
            <div className="section__body">
              <div className="row">
                <div className="column--third">
                  <div className="esport lol">
                    {this.state.isOpen && (
                      <Lightbox mainSrc={videos[this.state.index]} onCloseRequest={this.closeLightbox} />
                    )}
                    <div className="poster">
                      <Video data={video_data.smite} />
                      <div className="bg" />
                      <img src="/images/esports/lol/lol-logo.png" />
                    </div>
                    <a className="watch" onClick={this.openLol}>
                      <span>&#9658;</span> Watch trailer
                    </a>
                  </div>
                </div>
                <div className="column--twoThird">
                  <div className="section__head--leftAlign noMaxWidth">
                    <a name="lol"></a><h2>League of Legends</h2>
                    <p>
                      League of Legends is a fast-paced, multiplayer online battle arena (MOBA) game which
                      requires players to strategize to knock down enemy towers. Players assume the role of a
                      summoner and use the special abilities of their “champions” to outsmart their opponents.
                      League of Legends is one of the most popular esports titles in the world.
                    </p>
                  </div>
                  <div className="section__body--leftAlign noMaxWidth">
                    <dl>
                      <div>
                        <dt>Released</dt>
                        <dd>October 27th, 2009</dd>
                      </div>
                      <div>
                        <dt>Genre</dt>
                        <dd>MOBA</dd>
                      </div>
                      <div>
                        <dt>Publisher</dt>
                        <dd>Riot Games</dd>
                      </div>
                      <div>
                        <dt>Game size</dt>
                        <dd>8 GB</dd>
                      </div>
                    </dl>
                  </div>
                  <div className="section__CTA--leftAlign noMaxWidth">
                    <a href="https://na.leagueoflegends.com/en/game-info/" target="_blank">
                      More about League of Legends
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section--shorten">
          <div className="container">
            <div className="section__body">
              <div className="row--reverse">
                <div className="column--third">
                  <div className="esport rleague">
                    <div className="poster">
                      <div className="bg" />
                      <img src="/images/esports/rl/rleague-logo.png" />
                    </div>
                  </div>
                </div>
                <div className="column--twoThird">
                  <div className="section__head--leftAlign noMaxWidth">
                    <a name="rocket-league"></a><h2>Rocket League</h2>
                    <p>
                      Rocket League combines two thrilling genres into a single game: soccer and driving.
                      Players must work together utilizing field formations during each five-minute match.
                      This “vehicular soccer” is a sports-action game that introduces a bit more physics, as
                      players grapple with exhilirating momentum and vehicular control in order to outscore
                      the opposing team.
                    </p>
                  </div>
                  <div className="section__body--leftAlign noMaxWidth">
                    <dl>
                      <div>
                        <dt>Released</dt>
                        <dd>July 7th, 2015</dd>
                      </div>
                      <div>
                        <dt>Genre</dt>
                        <dd>Sport</dd>
                      </div>
                      <div>
                        <dt>Publisher</dt>
                        <dd>Psyonix Inc</dd>
                      </div>
                      <div>
                        <dt>Game size</dt>
                        <dd>7 GB</dd>
                      </div>
                    </dl>
                  </div>
                  <div className="section__CTA--leftAlign noMaxWidth">
                    <a href="https://www.rocketleague.com/game-info/" target="_blank">
                      Learn more about Rocket League
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section--shorten">
          <div className="container">
            <div className="section__body">
              <div className="row">
                <div className="column--third">
                  <div className="esport smite">
                    <div className="poster">
                      <div className="bg" />
                      <img src="/images/esports/smite/smite-logo.png" />
                    </div>
                    {/*
                    <a className="watch" onClick={this.openSmite}>
                      <span>&#9658;</span> Watch trailer
                    </a>
                    */}
                  </div>
                </div>
                <div className="column--twoThird">
                  <div className="section__head--leftAlign noMaxWidth">
                    <a name="smite"></a><h2>SMITE</h2>
                    <p>
                      SMITE is a multiplayer online battle arena game where players work through map
                      objectives to ultimately defeat the opposing Titan. Each player becomes a mythological
                      figure and is equipped with a team of soldiers or “minions” who will aid them in battle.
                      SMITE players collaborate as a team and develop advanced game play strategies to win.
                    </p>
                  </div>
                  <div className="section__body--leftAlign noMaxWidth">
                    <dl>
                      <div>
                        <dt>Released</dt>
                        <dd>March 25th, 2014</dd>
                      </div>
                      <div>
                        <dt>Genre</dt>
                        <dd>MOBA</dd>
                      </div>
                      <div>
                        <dt>Publisher</dt>
                        <dd>Hi-Rez Studios</dd>
                      </div>
                      <div>
                        <dt>Game size</dt>
                        <dd>30 GB</dd>
                      </div>
                    </dl>
                  </div>
                  <div className="section__CTA--leftAlign noMaxWidth">
                    <a href="https://smite.gamepedia.com/SMITE" target="_blank">
                      Learn more about SMITE
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default BiColumn__games



// WEBPACK FOOTER //
// ./src/common/ui/components/biColumn__games.js